import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AppState, jobRestorationMediaFacadeBase } from '@app/state';
import { Store, select } from '@ngrx/store';
import { JobRestorationMedia } from '@app/models';

import { selectJobIncidentVMMediaByIncident } from '@app/state/job-incident-media.join-selectors';
import { JobRestorationMediaService } from '@services/api/job-restoration-media.service';
import {
  createJobRestorationMedia,
  CreateJobRestorationMediaRequest,
} from '@app/state/job-restoration-media.effects';
import { selectRestorationMediaVMByTicket } from '@app/state/job-restoration-media.join-selectors';

@Injectable({ providedIn: 'root' })
export class JobRestorationMediaFacade extends jobRestorationMediaFacadeBase {
  constructor(
    private store: Store<AppState>,
    private mediaService: JobRestorationMediaService
  ) {
    super(JobRestorationMedia, store);
  }

  imageLink$(media: JobRestorationMedia): Observable<string> {
    return this.mediaService.getLink(media.id);
  }

  createMedia(payload: CreateJobRestorationMediaRequest) {
    this.store.dispatch(createJobRestorationMedia({ payload }));
  }

  get mediaByTicket$() {
    return this.store.pipe(select(selectRestorationMediaVMByTicket));
  }
}
